<template>
  <div class="header-bottom">
    <div
      v-bind:class="{ 'header-nav-es': isActive, 'header-nav': !isActive }"
      class="vue-dropdown-menu"
    >
      <!-- <v-dropdown :active-url="$i18nRoute({ name: homeRedirectPath})" >
        <router-link slot="activator" :to="$i18nRoute({ name: homeRedirectPath})">
          <i class="icon-fa icon-fa-home"/>
              {{ $t("pages.home") }}
        </router-link>


      </v-dropdown>-->

      <v-dropdown
        v-for="(menu, index) in dynamicMenu"
        v-bind:key="index"
        :active-url="{
          name: 'home',
          params: { id: menu.title, endpoint: menu.endpoint },
        }"
      >
        <router-link
          v-if="isJsonObjectExist(menu, 'subMenus')"
          slot="activator"
          to="#"
          >{{ menu.title }}</router-link
        >

        <router-link
          v-else
          :to="{ name: 'home', params: { id: menu.title, menu } }"
          slot="activator"
          >{{ menu.title }}</router-link
        >

        <v-dropdown-item
          :if="isJsonObjectExist(menu, 'subMenus')"
          v-for="(smenu, index) in menu.subMenus"
          v-bind:key="index"
        >
          <router-link
            :to="{ name: 'home', params: { id: menu.title+' '+smenu.title, 'menu':smenu } }"
            >{{ smenu.title }}</router-link
          >
        </v-dropdown-item>
      </v-dropdown>
    </div>
  </div>
</template>


<script type="text/babel">
import Auth from "../.././../services/auth";
import { IS_SANDBOX_MODE } from "../../../helpers/envoirment";
export default {
  data() {
    return {
      role: Auth.userData().Profile,
      isActive: true,
      isAllowed: false,
      dynamicMenu: this.genrateDynamicMenu(),

      subMenus11: [
        {
          title: "Agentes",
          endpoint: "api/agents",
          type: "write|add|show",
        },
        {
          title: "Comerciales-Adssds",
          endpoint: "api/sellers",
          type: "write|show",
        },
        {
          title: "Resellers",
          endpoint: "api/resellers",
          type: "",
        },
        {
          title: "Roles Permisos",
          endpoint: "api/roles",
          type: "",
        },
        {
          title: "User Permisos",
          endpoint: "api/permissions",
          type: "write|add|show",
        },
        {
          title: "Ingresos",
          endpoint: "api/incomes",
          type: "",
        },
        {
          title: "Comisiones",
          endpoint: "api/commissions",
          type: "",
        },
        {
          title: "Productos",
          endpoint: "api/products",
          type: "|show",
        },
        {
          title: "Proveedores",
          endpoint: "api/providers",
          type: "|show",
        },
      ],
    };
  },

  created() {
    this.isAllowed = IS_SANDBOX_MODE;
  },

  methods: {
    genrateDynamicMenu() {
      // Auth.setEndPoint(menu.edpoint);
      return Auth.userData().menus;
    },
    isJsonObjectExist(obj, keytofind) {
      console.log(JSON.stringify(obj));
      console.log(keytofind);
      return Object.prototype.hasOwnProperty.call(obj, keytofind);
      //return Object.prototype.hasOwnProperty.call(obj, key);
    },
  },
};
</script>

<style  scoped>
.fillparent {
  display: block !important;
}
</style>
